import {
  Box,
  BoxProps,
  Button,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure,
} from '@chakra-ui/react';
import { FC, useRef, useState } from 'react';

import DrawerIcon from '@/assets/icons/ic-drawer.svg';
import NotificationIcon from '@/assets/icons/ic-notification.svg';

import { NotificationBadge } from '@/components/ui/shared/notifications/NotificationBadge/NotificationBadge';
import { Notifications } from '@/components/ui/shared/notifications/Notifications/Notifications';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';
import { ResourceType } from '@/enums/ResourceType';

// const DynamicDirectMessaging = dynamic(
//   () =>
//     import('@/components/ui/shared/direct-messaging/DirectMessaging/DirectMessaging').then(
//       (mod) => mod.DirectMessaging
//     ),
//   {
//     ssr: false,
//     loading: () => (
//       <Flex alignItems="center" justifyContent="center" h="full">
//         <CircleLoader size="lg" color="gray.200" />
//       </Flex>
//     ),
//   }
// );

export const SecondaryMenuMobile: FC<BoxProps> = ({ ...rest }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const btnRef = useRef();

  // const { eventId } = useQueryParams<{ eventId: string }>({
  //   eventId: StringParam,
  // });

  // const { data: event } = useResource([Event, eventId, { include: ['configuration'] }]);

  return (
    <Box {...rest}>
      <Button ref={btnRef} onClick={onOpen} variant="nav" w="3.5rem" ml="auto">
        <NotificationBadge resourceType={[ResourceType.Lecture, ResourceType.EventChatChannel]}>
          <DrawerIcon />
        </NotificationBadge>
      </Button>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={btnRef} size="full">
        <DrawerOverlay>
          <DrawerContent>
            <Tabs
              variant="nav"
              isLazy
              defaultIndex={selectedTabIndex}
              onChange={setSelectedTabIndex}
              display="flex"
              flexDirection="column"
            >
              <TabList>
                {/* {event.configuration.directMessaging && (
                  <Tab>
                    <NotificationBadge resourceType={ResourceType.EventChatChannel}>
                      <PeopleIcon />
                    </NotificationBadge>
                  </Tab>
                )} */}
                <Tab>
                  <NotificationBadge resourceType={ResourceType.Lecture}>
                    <NotificationIcon />
                  </NotificationBadge>
                </Tab>
                <DrawerCloseButton ml="auto" alignSelf="center" />
              </TabList>

              <TabPanels flex={1} minH={0}>
                {/* {event.configuration.directMessaging && (
                  <TabPanel p={0}>
                    <DynamicDirectMessaging />
                  </TabPanel>
                )} */}
                <TabPanel p={0}>
                  <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
                    <Notifications />
                  </BugsnagErrorBoundary>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
};
